import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import type { ListChannels } from '@/modules/connect/use-cases'
import type { LoadHuntTypesWithActivity } from '@/shared/domain'
import { NavPrefetchProvider, PageTitleProvider } from '@/shared/ui/providers'
import { SidebarInset, SidebarProvider } from '@/shared/ui/primitives'
import { AppSidebar } from './app-sidebar'
import { AppTopbar } from './app-topbar'
import { BillingBanners } from './billing-banners'
import { ImpersonationBanner } from './impersonation-banner'

const noopListChannels: ListChannels = () =>
  Promise.resolve({ channels: [], archivedChannels: [] })
const noopLoadHuntTypesWithActivity: LoadHuntTypesWithActivity = () => Promise.resolve([])

type AppShellProps = {
  children?: ReactNode
  onListChannels?: ListChannels
  onLoadHuntTypesWithActivity?: LoadHuntTypesWithActivity
}

export function AppShell({
  children,
  onListChannels = noopListChannels,
  onLoadHuntTypesWithActivity = noopLoadHuntTypesWithActivity,
}: AppShellProps) {
  return (
    <PageTitleProvider>
      <NavPrefetchProvider
        onListChannels={onListChannels}
        onLoadHuntTypesWithActivity={onLoadHuntTypesWithActivity}
      >
        <SidebarProvider>
          <AppSidebar />
          <SidebarInset className="h-dvh flex flex-col overflow-hidden bg-background text-foreground">
            <ImpersonationBanner />
            <BillingBanners />
            <AppTopbar className="bg-sidebar shrink-0" />
            <main className="flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden lg:overflow-hidden lg:bg-sidebar">
              <div className="flex w-full min-w-0 flex-col max-lg:flex-none lg:min-h-0 lg:flex-1 lg:overflow-hidden lg:rounded-tl-xl lg:bg-background">
                {children ?? <Outlet />}
              </div>
            </main>
          </SidebarInset>
        </SidebarProvider>
      </NavPrefetchProvider>
    </PageTitleProvider>
  )
}
